<template>
	<v-app id='inspire' :style='cStyle'>
		<v-container fluid fill-height :class="{ 'pa-0': isStreamingPage }">
			<v-fade-transition mode='out-in'>
				<router-view @change-style='onChangeStyle' />
			</v-fade-transition>
		</v-container>
	</v-app>
</template>

<script>
import('@homepage/css/main.scss');

export default {
	name: 'App',
	data() {
		return {
			style: {
				backgroundImage: null
			}
		};
	},
	methods: {
		onChangeStyle(payload) {
			Object.keys(payload).
				forEach(key => {
					this.$set(this.style, key, payload[key]);
				});
		}
	},
	computed: {
		cStyle() {
			const result = {};

			if (this.style.backgroundImage) {
				result['backgroundImage'] = `url(${this.style.backgroundImage})`;
			}

			return result;
		},
		isStreamingPage() {
			return this.$route.path.includes('/stream');
		}
	}
};
</script>

<style scoped>
#inspire {
	background-repeat: no-repeat;
	background-size: cover;
}
</style>
